module.exports = __webpack_public_path__ + "static/media/SolarWaterHeating.8dec3d58.png";